import styled from 'styled-components';

export const StyledTag = styled.div`
    ${({ theme, $backgroundColor, $color, onClick, $borderColor, disabled }) => `
    background-color: ${
        $backgroundColor ? theme.palette.common[$backgroundColor] : theme.palette.primary.main
    };
    border: 1px solid ${
        $borderColor
            ? theme.palette.common[$borderColor]
            : $backgroundColor
            ? theme.palette.common[$backgroundColor]
            : theme.palette.primary.main
    };
    border-radius: 25px;

    width: fit-content;
    height: 24px;
    color:${$color ? theme.palette.common[$color] : theme.palette.common.white};

    font-family:'Prompt';
    font-size: 14px;
    padding: 1px 16px;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: ${disabled ? 'not-allowed' : onClick ? 'pointer' : 'initial'};

    white-space: nowrap;

    `}
`;
